(() => {
  'use strict';
  const qaKey = 'nimall_knowledge_qa_session';
  const params = new URLSearchParams(window.location.search);
  const explicitTest = params.get('nimall_qa') === '1' || /^(internal_qa|nimall_geo_qa|geo_controlled_qa|codex_qa|qa|test)$/i.test(params.get('utm_source') || '') || params.get('utm_medium') === 'controlled';
  const previewParameter = params.has('preview_theme_id');
  const storageFlag = () => { try { return sessionStorage.getItem(qaKey) === '1'; } catch (_) { return false; } };
  const markTest = () => { try { sessionStorage.setItem(qaKey, '1'); } catch (_) {} };
  const normalize = value => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0640\u064B-\u065F\u0670\u06D6-\u06ED]/g, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();

  // Ignore question framing, but preserve negation, numbers and product facts.
  const stopWords = new Set('a an the is are do does this that it its of for to in on and or what which how can i my me هل ما ماذا هذا هذه هو هي من في على عن كل ال او و'.split(' '));
  const terms = value => normalize(value).split(' ').map(token => {
    if (/^و[\u0600-\u06ff]{4,}$/.test(token)) token = token.slice(1);
    // Arabic definite article and the common li+article contraction.
    if (/^[وفب]ال[\u0600-\u06ff]{3,}$/.test(token)) return token.slice(3);
    if (/^لل[\u0600-\u06ff]{3,}$/.test(token)) return token.slice(2);
    if (/^ال[\u0600-\u06ff]{3,}$/.test(token)) return token.slice(2);
    return token;
  }).map(token => token.length > 3 ? token.replace(/ة$/, '') : token).filter(token => token && !stopWords.has(token));
  document.querySelectorAll('[data-nimall-purchase-help]').forEach(root => {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const preview = root.dataset.themeRole !== 'main' || root.dataset.designMode === 'true' || previewParameter;
    if (explicitTest || preview) markTest();
    const trafficClass = explicitTest ? 'controlled_test' : preview ? 'draft_preview' : storageFlag() ? 'controlled_test_session' : 'unclassified_live';
    root.dataset.trafficClass = trafficClass;
    root.dataset.trackingState = trafficClass === 'unclassified_live' ? 'awaiting_interaction' : 'excluded_' + trafficClass;
    const qaDiagnostic = explicitTest && params.get('nimall_measurement_qa') === '1' && ['188164669714', '188171026706'].includes(root.dataset.themeId);
    const sent = new Set();
    const emit = (action, itemId) => {
      root.dataset.lastAction = action;
      root.dataset.lastItemId = itemId;
      if (trafficClass !== 'unclassified_live' && !qaDiagnostic) return;
      const shopify = window.Shopify;
      let allowed = false;
      try { allowed = shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch (_) {}
      if (!allowed) { root.dataset.trackingState = 'consent_not_allowed'; return; }
      if (typeof shopify?.analytics?.publish !== 'function') { root.dataset.trackingState = 'publisher_unavailable'; return; }
      const key = action + ':' + itemId;
      if (sent.has(key)) return;
      sent.add(key);
      const payload = {
        schema_version: 1, cohort: root.dataset.cohort, action, item_id: itemId,
        product_id: root.dataset.productId, theme_id: root.dataset.themeId,
        locale: root.dataset.locale, traffic_class: qaDiagnostic ? 'controlled_test' : trafficClass,
        theme_role: root.dataset.themeRole,
        evidence_type: 'product_listing', collector_verified: false
      };
      try {
        const result = shopify.analytics.publish(qaDiagnostic ? 'nimall_knowledge:qa_purchase_help' : 'nimall_knowledge:purchase_help', payload);
        Promise.resolve(result).then(accepted => {
          root.dataset.trackingState = accepted === false ? 'publisher_rejected' : qaDiagnostic ? 'qa_event_bus_only' : 'event_bus_only';
          if (accepted === false) sent.delete(key);
        }).catch(() => { sent.delete(key); root.dataset.trackingState = 'publisher_failed'; });
      } catch (_) { sent.delete(key); root.dataset.trackingState = 'publisher_failed'; }
    };

    const details = [...root.querySelectorAll('details[data-answer-id]')];
    details.forEach(detail => {
      detail.addEventListener('toggle', () => { if (detail.open) emit('answer_open', detail.dataset.answerId); });
    });
    root.querySelectorAll('a[data-source-id]').forEach(link => {
      link.addEventListener('click', () => emit('source_link_click', link.dataset.sourceId));
    });

    const form = root.querySelector('[data-knowledge-search]');
    const input = root.querySelector('[data-knowledge-query]');
    const status = root.querySelector('[data-knowledge-status]');
    if (!form || !input || !status) return;

    const filter = submitted => {
      const query = normalize(input.value);
      const tokens = terms(query);
      let firstMatch = null;
      let firstMatchScore = 0;
      let matchCount = 0;
      details.forEach(detail => {
        const summary = detail.querySelector('summary')?.textContent || '';
        const answer = detail.querySelector('.nimall-purchase-help__answer p')?.textContent || '';
        const haystack = normalize(summary + ' ' + answer + ' ' + (detail.dataset.queryAliases || ''));
        const vocabulary = new Set(terms(haystack));
        const matched = !query || haystack.includes(query) || (tokens.length > 0 && tokens.every(token => vocabulary.has(token)));
        detail.hidden = !matched;
        if (matched) {
          matchCount += 1;
          const exactQuestion = query === normalize(summary);
          const exactAlias = (detail.dataset.queryAliases || '').split('||').some(alias => query === normalize(alias));
          const score = exactQuestion ? 3 : exactAlias ? 2 : 1;
          if (score > firstMatchScore) { firstMatch = detail; firstMatchScore = score; }
        } else {
          detail.open = false;
        }
      });
      status.hidden = matchCount > 0 || !query;
      root.dataset.searchMatchCount = String(matchCount);
      if (!submitted || !query) return;
      if (firstMatch) {
        firstMatch.open = true;
        firstMatch.querySelector('summary')?.focus({ preventScroll: true });
        emit('search_match', firstMatch.dataset.answerId);
      } else {
        emit('search_no_match', 'no-match');
      }
    };

    input.addEventListener('input', () => filter(false));
    form.addEventListener('submit', event => {
      event.preventDefault();
      filter(true);
    });
  });
})();
